<template>
  <div class="membership">
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">
          {{ $t('list.editMembership') }}
        </h3>
      </div>
      <div class="box-body">
        <form-membership />
      </div>
    </div>
  </div>
</template>

<script>
import FormMembership from './Form'
export default {
  name: 'Edit',
  components: { FormMembership },
  metaInfo () {
    return {
      title: this.$t('string.editMembership'),
      titleTemplate: '%s | ' + process.env.VUE_APP_NAME
    }
  }
}
</script>

<style scoped>

</style>
